import BottomSheet from "components/BottomSheet/BottomSheet";
import CustomButtonV2 from "components/CustomButtonV2/CustomButtonV2";
import { useProfile } from "contexts/ProfileContext";
import { useTabela } from "contexts/Tabela";
import { useToast } from "contexts/ToastContext";
import Button from "core/components/Button";
import IconButton from "core/components/IconButton";
import { AnimatePresence, motion } from "framer-motion";
import { values } from "lodash";

interface FooterEmbarqueProps {
	onClickOpenSomatorio: () => void;
	refDropdown: React.RefObject<HTMLDivElement>;
	isOpenDropdown: boolean;
	toggleDropdown: () => void;
	acoesData: { titulo: string; onClick: () => void }[];
	buscandoEmbarqueEDependencias: boolean;
	setOpenUsuario: React.Dispatch<React.SetStateAction<boolean>>;
	openMoreOptions: boolean;
	setOpenMoreOptions: React.Dispatch<React.SetStateAction<boolean>>;
	buscarEmbarquePorId: (flag: boolean) => void;
	handleClickCadastrar: () => void;
	handleClickEdit: () => void;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setTextoSucesso: React.Dispatch<React.SetStateAction<string>>;
}

function FooterEmbarque({
	onClickOpenSomatorio,
	refDropdown,
	isOpenDropdown,
	toggleDropdown,
	acoesData,
	buscandoEmbarqueEDependencias,
	setOpenUsuario,
	openMoreOptions,
	setOpenMoreOptions,
	buscarEmbarquePorId,
	handleClickCadastrar,
	handleClickEdit,
	setOpen,
	setTextoSucesso,
}: FooterEmbarqueProps) {
	const { contextoEmbarque } = useProfile();
	const { tabelaRedux } = useTabela();
	const { showToast } = useToast();

	return (
		<>
			<div className="footer-space-between">
				<div className="footer-row">
					<CustomButtonV2
						classCss="custom-button-cadastrar"
						classText="button-texto-cadastrar"
						icone="iconeSave"
						titulo="Cadastrar"
						cor="#0946B8"
						valor={values}
						onClick={handleClickCadastrar}
					/>
					<CustomButtonV2
						classCss="custom-button-editar"
						classText="button-texto-editar"
						titulo="Editar"
						icone="iconeEdit"
						cor="#CDCDCD"
						valor={values}
						onClick={handleClickEdit}
					/>
					<CustomButtonV2
						classCss="custom-button-deletar"
						classText="button-texto-cadastrar"
						titulo="Deletar"
						icone="iconeDelete"
						cor="#DC2D2D"
						valor={values}
						onClick={() => {
							if (tabelaRedux.colunaSelecionada) {
								setOpen(true);
								setTextoSucesso("Deletado Com Sucesso");
							} else {
								showToast("Selecione Uma Coluna", "error");
							}
						}}
					/>
				</div>
				<div className="footer-row-end">
					{contextoEmbarque !== "templateEmbarque" && (
						<>
							<CustomButtonV2
								classCss="custom-button-user"
								classText="button-texto-faturamento"
								titulo={"Exibir Somatório"}
								cor="#FFFFFF"
								onClick={onClickOpenSomatorio}
							/>
							<div className="hover-emb" ref={refDropdown}>
								<AnimatePresence mode="wait">
									{isOpenDropdown && (
										<motion.div
											initial={{ opacity: 0, y: 20 }}
											animate={{ opacity: 1, y: 0 }}
											exit={{ opacity: 0, y: 20 }}
											transition={{ duration: 0.3 }}
											className="acoes-dropdown"
										>
											{acoesData.map((acao) => (
												<motion.p
													key={acao.titulo}
													onClick={acao.onClick}
													initial={{ scale: 1, backgroundColor: "#fff" }}
													whileHover={{
														scale: 1.03,
														backgroundColor: "#f0f0f0",
													}}
													whileTap={{ scale: 0.95 }}
													transition={{ duration: 0.2 }}
												>
													{acao.titulo}
												</motion.p>
											))}
										</motion.div>
									)}
								</AnimatePresence>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Ações"
									cor="#FFFFFF"
									valor={values}
									disabled={buscandoEmbarqueEDependencias}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											toggleDropdown();
										} else {
											showToast("Selecione uma coluna", "error");
										}
									}}
								/>
							</div>
						</>
					)}
					<CustomButtonV2
						classCss="custom-button-user"
						classText="button-texto-user"
						titulo="Obter Usuário"
						cor="#FFFFFF"
						valor={values}
						onClick={() => {
							if (tabelaRedux.usuarioAlteracao) {
								setOpenUsuario(true);
							} else {
								showToast("Selecione Uma Coluna", "error");
							}
						}}
					/>
					{contextoEmbarque !== "templateEmbarque" && (
						<CustomButtonV2
							classCss="custom-button-historico"
							classText="button-texto-user"
							titulo="Histórico"
							cor="#FFFFFF"
							valor={values}
							onClick={() => {
								if (tabelaRedux.colunaSelecionada) {
									buscarEmbarquePorId(true);
								} else {
									showToast("Selecione Uma Coluna", "error");
								}
							}}
						/>
					)}
				</div>
			</div>
			<div className="footer-mobile">
				<Button
					label="Cadastrar"
					icon="Save"
					iconTheme="light"
					iconSize="md"
					theme="primary"
					radius="md"
					size="xs"
					onClick={handleClickCadastrar}
				/>
				<Button
					label="Editar"
					icon="Pencil"
					iconTheme="light"
					theme="secondary"
					iconSize="md"
					radius="md"
					size="xs"
					onClick={handleClickEdit}
				/>
				<IconButton
					icon="Plus"
					size="lg"
					borderColor="#c3c3c3"
					backgroundColor="rgba(0, 0, 0, 0)"
					theme="dark"
					onClick={() => setOpenMoreOptions(true)}
				/>
			</div>

			<BottomSheet
				open={openMoreOptions}
				onClose={() => setOpenMoreOptions(false)}
				title="Mais opções"
			>
				<p
					onClick={() => {
						setOpenMoreOptions(false);
						if (tabelaRedux.colunaSelecionada) {
							setOpen(true);
							setTextoSucesso("Deletado Com Sucesso");
						} else {
							showToast("Selecione Uma Coluna", "error");
						}
					}}
				>
					Deletar
				</p>

				<p
					onClick={() => {
						setOpenMoreOptions(false);
						onClickOpenSomatorio();
					}}
				>
					Exibir Somatório
				</p>

				<p
					onClick={() => {
						setOpenMoreOptions(false);
						if (tabelaRedux.usuarioAlteracao) {
							setOpenUsuario(true);
						} else {
							showToast("Selecione Uma Coluna", "error");
						}
					}}
				>
					Obter Usuário
				</p>

				<p
					onClick={() => {
						setOpenMoreOptions(false);
						if (tabelaRedux.colunaSelecionada) {
							buscarEmbarquePorId(true);
						} else {
							showToast("Selecione Uma Coluna", "error");
						}
					}}
				>
					Histórico
				</p>
				{acoesData
					.sort((a, b) => a.titulo.localeCompare(b.titulo))
					.map((acao) => (
						<p
							key={acao.titulo}
							onClick={() => {
								setOpenMoreOptions(false);
								if (typeof acao.onClick === "function") acao.onClick();
							}}
						>
							{acao.titulo}
						</p>
					))}
			</BottomSheet>
		</>
	);
}

export default FooterEmbarque;
